import * as React from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

interface SearchInputProps
  extends Omit<React.ComponentProps<typeof Input>, "onChange" | "value"> {
  value: string;
  onChange: (value: string) => void;
  /** Classe do wrapper relativo (largura, flex-grow). */
  containerClassName?: string;
}

/**
 * Campo de busca padrão: ícone à esquerda + `pl-9` consistentes, largura total
 * no mobile e crescendo numa toolbar a partir de `sm`. Elimina o idiom
 * copiado-e-colado (pl-8/pl-9, left-2/2.5/3 divergentes) espalhado pelas listas.
 */
export function SearchInput({
  value,
  onChange,
  className,
  containerClassName,
  placeholder = "Buscar...",
  ...props
}: SearchInputProps) {
  return (
    <div className={cn("relative w-full sm:min-w-[240px] sm:flex-1", containerClassName)}>
      <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        className={cn("pl-9", className)}
        {...props}
      />
    </div>
  );
}

export default SearchInput;
